<template>
  <div class="dialog_wrap" page-data="index:index" style="display: block;">
    <div class="dialog_layout">
      <div class="dialog_container">
        <img src="http://site.cc/static/txys-001/image/loading.gif" class="loading_img" style="display: none;">
        <div class="form_warp" style="display: block;">
          <div class="dialog_title">
            <span class="title"></span>
            <i class="dialog_close iconfont icon-chuyidong" @click="onClickCloseBtn"></i>
          </div>
          <div class="dialog_content">
            <form class="my_form form-horizontal" id="forms">
              <div class="form_content">
                <div class="form-tip-job">{{$t('widgets_basic_job_components_table1_2521')}}</div>
                <input type="hidden" name="id" id="id" value="5">
                <div class="form_item_wrap" data-comb-dom="" style="width:33%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('widgets_basic_job_components_table1_2522')}}</span><span
                    class="required_icon">*</span></h3><input disabled autocomplete="off" maxlength="20" id="name"
                                                              name="name"
                                                              :placeholder="$t('view_test_2503')"
                                                              class="input_style jz_focus jz_theme_focus_border_color">
                  </div>
                </div>
                <div class="form_item_wrap" data-comb-dom="" style="width:33%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('base_options_config_1784')}}</span><span
                    class="required_icon">*</span></h3>
                    <div class="item_type_phone content">
                      <div class="phone_number_area">
                        <div class="phone_number_wrap">
                          <input disabled autocomplete="off" maxlength="11" id="phone" name="phone"
                                 :placeholder="$t('view_login_index_48')"
                                 class="input_style jz_focus jz_theme_focus_border_color">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form_item_wrap" data-comb-dom="" style="width:34%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('widgets_basic_job_components_table1_2523')}}</span><span
                    class="required_icon">*</span></h3><input disabled autocomplete="off" maxlength="50" id="email"
                                                              name="email"
                                                              :placeholder="$t('widgets_basic_job_components_table1_2524')"
                                                              class="input_style jz_focus jz_theme_focus_border_color">
                  </div>
                </div>
                <div class="form_item_wrap form_item_wrap-resume" data-comb-dom="" style="width:100%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('widgets_basic_job_components_table1_2525')}}</span></h3>
                    <div class="item_type_textarea content form-content-resume">
                      <table class="basic-job-resume resume-table-u711703 table-2" style="display: table;">
                        <!-- <thead>
                          <tr>
                            <th colspan="8" style="text-align: left;">基本情况</th>
                          </tr>
                        </thead>-->
                        <tbody>
                        <tr>
                          <td>
                            <span class="label label-name"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="name" class="txt input-name">
                          </td>
                          <td>
                            <span class="label label-nationality"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="nationality" class="txt input-nationality">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-mailing_address"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="mailing_address" class="txt input-">
                          </td>
                          <td>
                            <span class="label label-nation"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="nation" class="txt input-nation">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-native_place"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="native_place" class="txt input-native_place">
                          </td>
                          <td>
                            <span class="label label-sex"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="sex" class="txt input-sex">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-married"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="married" class="txt input-married">
                          </td>
                          <td>
                            <span class="label label-age"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="age" class="txt input-age">
                          </td>
                        </tr>
                        <tr>
                          <td colspan="8">
                            <strong>
                              <span class="label label-title_second_1"></span>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-talent_type"></span>
                          </td>
                          <td colspan="7">
                            <input type="text" data-field="talent_type" class="txt input-talent_type">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-expire_position"></span>
                          </td>
                          <td colspan="7">
                            <input type="text" data-field="expire_position" class="txt input-expire_position">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-work_year"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="work_year" class="txt input-work_year">
                          </td>
                          <td>
                            <span class="label label-major_title"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="major_title" class="txt input-major_title">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-expire_type"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="expire_type" class="txt input-expire_type">
                          </td>
                          <td>
                            <span class="label label-available_date"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="available_date" class="txt input-available_date">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-salary"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="salary" class="txt input-salary">
                          </td>
                          <td>
                            <span class="label label-expire_place"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="expire_place" class="txt input-expire_place">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-job_experience"></span>
                          </td>
                          <td colspan="7">
                            <input type="text" data-field="job_experience" class="txt input-job_experience">
                          </td>
                        </tr>
                        <tr></tr>
                        <tr>
                          <td colspan="8">
                            <strong>
                              <span class="label label-title_second_2"></span>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-graduated_school"></span>
                          </td>
                          <td colspan="7">
                            <input type="text" data-field="graduated_school" class="txt input-graduated_school">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-best_education"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="best_education" class="txt input-best_education">
                          </td>
                          <td>
                            <span class="label label-graduated_date"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="graduated_date" class="txt input-graduated_date">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-major"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="major" class="txt input-major">
                          </td>
                          <td>
                            <span class="label label-second_major"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="second_major" class="txt input-second_major">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-train"></span>
                          </td>
                          <td colspan="7">
                            <input type="text" data-field="train" class="txt input-train">
                          </td>
                        </tr>
                        <tr>
                          <td colspan="8">
                            <strong>
                              <span class="label label-title_second_3"></span>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-english_level"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="english_level" class="txt input-english_level">
                          </td>
                          <td></td>
                          <td colspan="3">
                            <input type="text" data-field="" class="txt input-">
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="label label-mandarin_level"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="mandarin_level" class="txt input-mandarin_level">
                          </td>
                          <td>
                            <span class="label label-cantonese_level"></span>
                          </td>
                          <td colspan="3">
                            <input type="text" data-field="cantonese_level" class="txt input-cantonese_level">
                          </td>
                        </tr>
                        <tr>
                          <td colspan="8">
                            <strong>
                              <span class="label label-other_skill"></span>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="8">
                            <input type="text" data-field="talent_type" class="txt input-other_skill">
                          </td>
                        </tr>
                        <tr>
                          <td colspan="8">
                            <strong>
                              <span class="label label-self_evaluate"></span>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="8">
                            <input type="text" data-field="self_evaluate" class="txt input-self_evaluate">
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div v-for="(value, key) in mobileLabelMap" :key="key" class="form_item_wrap form_item_wrap_mb"
                     style="width:100%">
                  <div class="form_item">
                    <h3 class="title"><span class="title_text">{{ value }}</span></h3>
                    <input
                      autocomplete="off" disabled maxlength="20"
                      ::placeholder="$t('widgets_basic_job_components_table1_2526', [value])"
                      class="input_style jz_focus jz_theme_focus_border_color">
                  </div>
                </div>
                <div style="width:69%" class="form_item_wrap fixed_item formitem_validateCode" data-comb-dom="">
                  <div class="form_item">
                    <div class="item_type_validateCode content">
                      <input disabled autocomplete="off" :placeholder="$t('view_login_index_47')" maxlength="4" id="verify" name="verify"
                             class="validateCode_input input_style jz_focus jz_theme_focus_border_color">
                      <img alt=" " src="/static/image/verify.png" class="validateCode_img">
                    </div>
                  </div>
                </div>
                <div style="width:11%" class="form_item_wrap fixed_item formitem_submit" data-comb-dom="">
                  <div class="form_item" style="text-align: center">
                    <button class="form_submit content jz_theme_bg_color" type="button" @click="onClickSubmitBtn">{{$t('widgets_basic_job_components_table1_2527')}}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: "basic_job_table2",
  data() {
    return {
      styleType: 2,
      widgetId: '',
      labelMap: {},
      mobileExcludeKeys: ['name', 'phone', 'email']
    }
  },
  computed: {
    mobileLabelMap() {
      return Object.keys(this.labelMap).filter(key => !this.mobileExcludeKeys.includes(key) && this.labelMap[key]).map(key => this.labelMap[key])
    }
  },
  methods: {
    onClickSubmitBtn() {
      this.$message({showClose: true, message: i18n.t('components_set_link_components_submit_form_index_2470')});
    },
    onClickCloseBtn() {
      this.close()
    },
    close() {
      $(this.$el).remove()
    }
  }
}
</script>

<style scoped lang="scss">
@import "./src/css/components/basic_job_table";
</style>



// WEBPACK FOOTER //
// src/widgets/basic_job/components/table2.vue